import { useEffect, useContext } from "react";
import {
    Backdrop,
    CircularProgress
} from '@mui/material';

import 'Styles/Loader.scss'

import { useNavigate } from "react-router";
import UserContext from 'Interfaces/Context';

//Metodos de servicios
import { getDataInitialUser } from "Services/Authentication";
import { getDocument } from "Services/Firebase";
import { auth as FirebaseAuth } from "Services/Authentication"
import { useAuth } from "Context/Auth/useAuth";

interface LoaderProps {
    openLoader: boolean;
    inPage: boolean;
    redirect: boolean;
    redirectHome: boolean
    quantity: number
}

const Loader = (props: LoaderProps) => {
    const navigate = useNavigate()
    const auth = useAuth()
    const context = useContext(UserContext);

    //Funcion de carga
    useEffect(() => {
        if (props.redirect && props.redirectHome) {
            FirebaseAuth.onAuthStateChanged(async (firebaseUser: any) => {
                if (firebaseUser === null) {
                    navigate('/login')
                    auth.setAuth({
                        uid: '',
                        auth: false,
                        token: ''
                    })
                } else {
                    await getDataInitial()
                    let user: any = await getDataInitialUser(firebaseUser?.uid, context.service.router.POST.get_user_information)
                    auth.setAuth({
                        uid: user.id ?? "",
                        auth: true,
                        token: user.token ?? ""
                    })
                    auth.setUser({
                        id: user.id ?? "",
                        lastName: user.last_name ?? "",
                        name: user.name ?? "",
                        email: user.email ?? "",
                        vendorCode: user.vendorCode ?? "",
                        salesPersonCode: user.salesPersonCode ?? "",
                        priceList: user.priceList ?? 0,
                        branchOffice: user.branchOffice ?? 0,
                        role: user.role ?? "",
                        codeCellar: user.codeCellar ?? "",
                        documentUser: user.documentUser ?? "",
                        phone: user.phone ?? "",
                        creationDate: user.creationDate ?? "",
                        lastLogin: user.lastLogin ?? "",
                        device: user.device ?? "",
                        vendorName: user.vendorName ?? "",
                        buyerCode: user.buyerCode ?? ""
                    })
                    if (props.redirect) navigate('/home/comercial')
                }
            });
        }

        // eslint-disable-next-line
    }, [])

    //Trae la informacion inicial
    const getDataInitial = async () => {
        FirebaseAuth.onAuthStateChanged(async (firebaseUser: any) => { });
        let element = await getDocument("configurations", `${process.env.REACT_APP_CONFIGURATION_REQUEST}`)
        context.assignateRouter(element)
        navigate('/home/comercial')

    }

    return (
        <div>
            {
                props.inPage ?
                    <div className="loaderContent">
                        <CircularProgress color="inherit" />
                    </div>
                    :
                    props.redirect ?
                        <Backdrop
                            sx={{ color: '#ffffff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={props.openLoader}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                        :
                        <Backdrop
                            sx={{ color: '#000', backgroundColor: '#ffffff' }}
                            open={props.openLoader}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>

            }
        </div>
    )
}

export default Loader;